
import { EkonomiskAnalysStandardColumnQuery_ekanalysstandardcolumns } from '../Queries/EkonomiskAnalysStandardColumnQuery/_QueryTypes/EkonomiskAnalysStandardColumnQuery';
import { ekanalys_ekanalys_columns } from '../../../../../../../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';
import { INewColumnData } from '../EkonomiskAnalysEditColumnDialog/EkonomiskAnalysEditColumnDialog';
import {
  EkonomiskAnalysEditColumnFormValuesType,
  ColumnFaltkodType,
} from '../EkonomiskAnalysEditColumnForm';
import { editColumnFormValuesToColumn } from '../../Utils/EkonomiskAnalysConvertEditColumnFormValuesToColumn';
import {
  getStandardColumnTitle,
  getStandardColumnSubTitle,
  findStandardColumnByFaltkod,
} from '../../Utils/EkonomiskAnalysEditColumnUtils';
import Field from '../../../../../../../../../../../../BaseComponents/Forms/EDField';
import { SetFieldValueType } from '../../../../../../../../../../../../Types/FormTypes';
import { StandardColumnType } from '../Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import EkonomiskAnalysStandardColumnField from './EkonomiskAnalysStandardColumnField';
import EkonomiskAnalysEditColumnTitleField from './EkonomiskAnalysEditColumnTitleField';

interface IProps {
  standardColumns?: EkonomiskAnalysStandardColumnQuery_ekanalysstandardcolumns[];
  initialColumn: ekanalys_ekanalys_columns;
  newColumnData: INewColumnData;
  formValues: EkonomiskAnalysEditColumnFormValuesType;
  setFieldValue: SetFieldValueType;
  column?: ekanalys_ekanalys_columns;
}

const onStandardColumnChange =
  (
    onChange: (newValue: string | null) => void,
    setFieldValue: SetFieldValueType,
    standardColumns: StandardColumnType[],
    formValues: EkonomiskAnalysEditColumnFormValuesType
  ) =>
  (newValue: string | null) => {
    const standardColumn = findStandardColumnByFaltkod(
      newValue as ColumnFaltkodType,
      standardColumns
    );
    setFieldValue('title', getStandardColumnTitle(standardColumn));
    setFieldValue(
      'subTitle',
      getStandardColumnSubTitle(
        standardColumn,
        formValues.fromPeriodChecked,
        formValues.tomPeriodChecked
      )
    );

    if (
      (standardColumn &&
        standardColumn.TOMAR &&
        standardColumn.TOMPER &&
        formValues.fromPeriodChecked &&
        formValues.tomPeriodChecked) ||
      formValues.timeInterval === 1
    ) {
      // Detta är en period
      setFieldValue('rullande', formValues.rullande);
    } else {
      setFieldValue('rullande', false);
    }

    if (standardColumn && standardColumn.INGAENDE) {
      setFieldValue('tomPeriod', formValues.fromPeriod);
    }

    onChange(newValue);
  };

const EkonomiskAnalysEditColumnColumnTitle: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    formValues,
    initialColumn,
    standardColumns,
    newColumnData,
    setFieldValue,
    column,
  } = props;

  const columnTypes: EkonomiskAnalysEditColumnFormValuesType[] = standardColumns
    ? standardColumns.map(x => ({
        columnOrigin: (x.FALTKOD || '') as ColumnFaltkodType,
        displayLabel: formValues.displayLabel,
        title: getStandardColumnTitle(x),
        subTitle: getStandardColumnSubTitle(
          x,
          formValues.fromPeriodChecked,
          formValues.tomPeriodChecked
        ),
        columnType: formValues.columnType,
        columnUnit: formValues.columnUnit,
        timeInterval: formValues.timeInterval,
        fromAr: formValues.fromAr,
        fromArChecked: formValues.fromArChecked,
        fromPeriod: formValues.fromPeriod,
        fromPeriodChecked: formValues.fromPeriodChecked,
        tomAr: formValues.tomAr,
        tomArChecked: formValues.tomArChecked,
        tomPeriod:
          x && x.INGAENDE ? formValues.fromPeriod : formValues.tomPeriod,
        tomPeriodChecked: formValues.tomPeriodChecked,
        budget: formValues.budget,
        budgetType: formValues.budgetType,
        flipSign: formValues.flipSign,
        rullande:
          (x &&
            x.TOMAR &&
            x.TOMPER &&
            formValues.fromPeriodChecked &&
            formValues.tomPeriodChecked) ||
          formValues.timeInterval === 1
            ? formValues.rullande
            : false,
      }))
    : [];

  const columns = columnTypes.map(x =>
    editColumnFormValuesToColumn(
      x,
      initialColumn,
      standardColumns || [],
      newColumnData.dates
    )
  );

  return (
    <Field name="columnOrigin">
      {({ value, onChange, onBlur, touched, fieldErrors }) => {
        const columnChange = onStandardColumnChange(
          onChange,
          setFieldValue,
          standardColumns || [],
          formValues
        );
        return (
          <>
            <EkonomiskAnalysStandardColumnField
              columnChange={columnChange}
              standardColumns={standardColumns}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              touched={touched}
              fieldErrors={fieldErrors}
            />
            <EkonomiskAnalysEditColumnTitleField
              columnChange={columnChange}
              standardColumns={columns}
              column={column}
              newColumnData={newColumnData}
            />
          </>
        );
      }}
    </Field>
  );
};

export default EkonomiskAnalysEditColumnColumnTitle;
